module.exports = __webpack_public_path__ + "img/store-touxiang-icon@2x.2517b910.png";